<template>
  <v-app>
    <Messages />
    <div style="height: 100%" class="d-flex flex-column align-center justify-center">
      <Loader />
      <span>{{ $store.getters.globalLoadingHint }}</span>
    </div>
  </v-app>
</template>

<script>
import Messages from '../components/messages'
import Loader from '../icons/Loader.vue'

export default {
  components:{
    Messages,
    Loader
  }
}
</script>